export enum OnlineFunnel {
  FLIGHTS = "flights",
  DYNPACK = "dynpack",
  HOTELS = "hotels",
  CARS = "cars",
}
